// A thin wrapper around the Intercom chat API, which we use for in-app help.
// Note: this only effects the button, not the in-app help panel that is opened by the button
var setInAppHelpButtonVisibility = function (isVisible) {
    // The chat widget doesn't render in all environments, so we must always check
    // for its presense before trying to interact with it.
    if (window.Intercom) {
        // eslint-disable-next-line new-cap
        window.Intercom('update', {
            hide_default_launcher: !isVisible
        });
    }
};
var hideInAppHelpButton = function () { return setInAppHelpButtonVisibility(false); };
var showInAppHelpButton = function () { return setInAppHelpButtonVisibility(true); };
export { hideInAppHelpButton, showInAppHelpButton };
//# sourceMappingURL=inAppHelpUtils.js.map